import React from 'react'
import { Box } from '@mui/material'
import theme from '../theme'

interface Props {
  sidebar: React.ReactNode
  content: React.ReactNode
  barPosition?: 'left' | 'right'
}

const TwoColumnLayout = ({ sidebar, content, barPosition = 'left' }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        padding: '0 40px 40px 40px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          width: '100%'
        }}
      >
        {barPosition === 'left' && (
          <Box
            sx={{
              width: '25%',
              backgroundColor: theme.palette['sage-800'],
              borderRadius: theme.borders['rounded-16'],
              height: 'fit-content'
            }}
          >
            {sidebar}
          </Box>
        )}
        <Box
          sx={{
            width: '75%',
            display: 'flex',
            flexDirection: 'column',
            height: 'fit-content'
          }}
        >
          {content}
        </Box>
        {barPosition === 'right' && (
          <Box
            sx={{
              width: '23%',
              backgroundColor: theme.palette['sage-800'],
              borderRadius: theme.borders['rounded-16'],
              height: 'fit-content',
              position: 'fixed',
              top: '120px',
              right: '20px'
            }}
          >
            {sidebar}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default TwoColumnLayout
